import { render } from "./prospect-list.vue?vue&type=template&id=827ea45c&scoped=true"
import script from "./prospect-list.vue?vue&type=script&lang=js"
export * from "./prospect-list.vue?vue&type=script&lang=js"

import "./prospect-list.vue?vue&type=style&index=0&id=827ea45c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-827ea45c"]])

export default __exports__